import { DocumentCategory, DocumentType, ImageSide } from 'shared/data/walletsKyc/v1';

import { excludeTimeFromDate } from '../helpers';
import type { FormValues } from '../types';
import { useUploadKycDocument } from './useUploadKycDocument';

export const useStepSubmission = () => {
    const { onUploadDocuments } = useUploadKycDocument();

    const handleStepSubmit = async (values: FormValues) => {
        const {
            accountUsage: { askForInitialCapital, ...accountUsage },
            additionalDocuments,
            businessInformation,
        } = values;
        const {
            documentSources = [],
            registeredAddress,
            tradingAddress,
            ...restBusinessInformation
        } = businessInformation;

        const businessInformationDocumentIds = documentSources?.length
            ? await onUploadDocuments(
                  DocumentType.proof_of_business_activity,
                  DocumentCategory.proof_of_business_activity,
                  documentSources.map((documentSource) => ({
                      images: [
                          {
                              ...documentSource,
                              imageSide: ImageSide.front,
                          },
                      ],
                  }))
              )
            : [];

        const additionalDocumentsProofOfFundsDocumentIds = additionalDocuments.proofOfFunds?.length
            ? await onUploadDocuments(
                  DocumentType.proof_of_source_of_funds,
                  DocumentCategory.proof_of_source_of_funds,
                  additionalDocuments.proofOfFunds.map((documentSource) => ({
                      images: [
                          {
                              ...documentSource,
                              imageSide: ImageSide.front,
                          },
                      ],
                  }))
              )
            : [];

        const additionalDocumentsOtherDocumentIds = additionalDocuments.other?.length
            ? await onUploadDocuments(
                  DocumentType.supporting,
                  DocumentCategory.supporting,
                  additionalDocuments.other.map((documentSource) => ({
                      images: [
                          {
                              ...documentSource,
                              imageSide: ImageSide.front,
                          },
                      ],
                  }))
              )
            : [];

        return {
            accountUsage,
            additionalDocuments: {
                documentIds: [...additionalDocumentsProofOfFundsDocumentIds, ...additionalDocumentsOtherDocumentIds],
            },
            businessInformation: {
                ...restBusinessInformation,
                documents: undefined,
                documentIds: businessInformationDocumentIds,
                incorporationDate: businessInformation.incorporationDate
                    ? excludeTimeFromDate(businessInformation.incorporationDate)
                    : undefined,
                registeredAddress,
                tradingAddress: restBusinessInformation.areCompanyAddressesEqual ? registeredAddress : tradingAddress,
            },
        };
    };

    return { onStepSubmit: handleStepSubmit };
};
